﻿import { required } from 'vuelidate/lib/validators';
import checkoutService from '../../api/checkout';

export default {
    name: 'phonejack',
    template: '#phonejack-template',
    mounted() {
        this.$watch('$v.$invalid', () => {
            this.updateValidState();              
        });
        this.updateValidState();
              
        if (this.viewmodel.hasPhoneJack != null) {
            this.hasPhoneJack = this.viewmodel.hasPhoneJack.toString();
        }

    },
    data: () => ({
        hasPhoneJack: '',
    }),
    props: ['viewmodel', 'blockid'],
    validations: {
        hasPhoneJack: {
            required
        }
    },
    methods: { 
        setPhoneJack() {
            const parameters = { 
                hasPhoneJack: this.hasPhoneJack,
                blockId: this.blockid,
                hasFreeTechnician: this.viewmodel.hasFreeTechnician,
            };
            checkoutService.saveInfo(this.viewmodel.apiUrl,
                parameters,
                (data) => {  
                    this.$store.dispatch('updateBasket');
                },
                () => {  }
            );
        },
        updateValidState() { 
            var invalid = (!this.viewmodel.hasDoItYourSelfInstallation) ? false : this.$v.hasPhoneJack.$invalid;            
            this.$store.dispatch('updateValidState', { invalid: invalid, blockId: this.blockid});   
        }
    } 
}